export const companySorts = {
  POPULAR: {
    value: 'popular', // by default
    transPath: 'companies.sorts.mostPopular',
  },
  NAME: {
    value: 'name',
    transPath: 'companies.sorts.name',
  },
};
